module.exports = __webpack_public_path__ + "img/work_from_office4.03b8223e.png";